export const DEFAULT_LOCATION_PARAM = "near";
export const DISTANCE_PARAM = "distance";
export const LAT_PARAM = "lat";
export const LNG_PARAM = "lng";

/**
 * Returns the params a distance filter submits together, the location param first.
 *
 * @param {string} [locationParam] - the param the location submits under.
 * @returns {string[]}
 */
export function distanceFilterNames(locationParam = DEFAULT_LOCATION_PARAM) {
  return [locationParam, DISTANCE_PARAM, LAT_PARAM, LNG_PARAM];
}
